module.exports = __webpack_public_path__ + "static/media/location-king-ff7d77.d25a2913.svg";